<template>
  <v-dialog v-model="dialog" width="960">
    <template v-slot:activator="{ on: dialog }">
      <div class="link-modal-button-container">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              class="link-filter-button"
              large
              v-on="{ ...tooltip, ...dialog }"
            >
              <v-icon>mdi-filter</v-icon>
              <span>Filters</span>
            </v-btn>
          </template>
          <span>Link Filter(s)</span>
        </v-tooltip>
      </div>
    </template>

    <v-card raised class="pb-2">
      <v-toolbar flat dark color="primary">
        <v-toolbar-title>Manage Filters</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false"
          ><v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-3 pb-2">
        <div>
          <v-form ref="form" v-model="valid" lazy-validation="">
            <v-row>
              <v-col>
                <v-text-field
                  label="Url"
                  v-model="filters.url"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row> </v-row>

            <v-row> </v-row>

            <v-row>
              <v-col>
                <v-text-field
                  label="Anchor Text"
                  v-model="filters.anchor_text"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  label="Pre Text"
                  v-model="filters.pre_text"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field
                  label="Title Tag"
                  v-model="filters.title_tag"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  label="Page Topic"
                  v-model="filters.page_topic"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select
                  label="Date Type"
                  outlined
                  dense
                  v-model="filters.date_field"
                  :items="date_field_options"
                  hide-details="auto"
                ></v-select>
              </v-col>
              <v-col>
                <v-menu
                  ref="startMenu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startDateFormatted"
                      label="Start Date"
                      placeholder="MM/DD/YYYY"
                      persistent-hint
                      clearable
                      outlined
                      dense
                      hide-details="auto"
                      v-on:keyup.enter="
                        filters.start_date = parseDate(startDateFormatted)
                      "
                      @blur="filters.start_date = parseDate(startDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.start_date"
                    no-title
                    color="secondary"
                    @input="startMenu = false"
                    :max="
                      filters.end_date
                        ? parseDate(filters.end_date)
                        : parseDate(today)
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  ref="endMenu"
                  v-model="endMenu"
                  :close-on-content-click="false"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endDateFormatted"
                      label="End Date"
                      placeholder="MM/DD/YYYY"
                      persistent-hint
                      clearable
                      outlined
                      dense
                      hide-details="auto"
                      v-on:keyup.enter="
                        filters.end_date = parseDate(endDateFormatted)
                      "
                      @blur="filters.end_date = parseDate(endDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.end_date"
                    no-title
                    color="secondary"
                    @input="endMenu = false"
                    :min="filters.start_date"
                    :max="parseDate(today)"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>

      <v-card-actions class="px-6 pt-0 pb-4">
        <v-spacer></v-spacer>
        <v-btn text @click="resetFilters">Reset Filters</v-btn>
        <v-btn color="success" dark @click="applyFilters">Apply Filters</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  props: ["headers", "modalData"],
  data() {
    return {
      dialog: false,
      valid: true,
      statusItems: [
        { text: "Active", value: 1 },
        { text: "Inactive", value: 0 },
      ],
      filters: null,
      endMenu: false,
      startMenu: false,
      startDateFormatted: null,
      endDateFormatted: null,
      date_field_options: [
        { value: "created_at", text: "Created" },
        { value: "updated_at", text: "Updated" },
      ],
      dateFormat: {
        format: "MM/DD/YYYY",
        parse: "YYYY-MM-DD",
        display: "MMM D, YYYY",
      },
    };
  },
  methods: {
    replaceUndefinedOrNull(key, value) {
      if (value === null || value === undefined) {
        return undefined;
      }

      return value;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(date).format(this.dateFormat.parse);
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format(this.dateFormat.format);
    },
    applyFilters() {
      console.log(this.filters);
      this.$store.dispatch("filters/setFilters", this.filters);
      this.dialog = false;
      this.$emit("filtersUpdated");
      //this.$parent.toggleModal(this.modalData);
      //console.log(this.modalData);
      this.$emit("fetchLinks");
    },
    resetFilters() {
      this.$store.dispatch("filters/clearFilters");
      this.filters = this.getDefaultFilters();
      this.$emit("fetchLinks");
    },
    getDefaultFilters() {
      return {
        url: null,
        project_id: null,
        domain: null,
        subdomain: null,
        domain_status: null,
        subdomain_status: null,
        disavow_status: null,
        anchor_text: null,
        pre_text: null,
        title_tag: null,
        page_topic: null,
        start_date: null,
        end_date: null,
        date_field: "created_at",
      };
    },
    getHeader(id) {
      let header = this.headers.find((header) => header.value === id);
      return header ? header : false;
    },
    getHeaderType(id) {
      let header = this.getHeader(id);
      return header ? header.filterType : false;
    },
    getHeaderText(id) {
      let header = this.getHeader(id);
      return header ? header.text : false;
    },
  },
  watch: {
    "filters.start_date"(val) {
      this.startDateFormatted = this.formatDate(val);
    },
    "filters.end_date"(val) {
      this.endDateFormatted = this.formatDate(val);
    },
  },
  computed: {
    today() {
      return moment();
    },
    ...mapGetters({
      activeFilters: "filters/filters",
    }),
  },
  created() {
    if (Object.keys(this.activeFilters).length !== 0) {
      this.filters = this.activeFilters;
    } else {
      this.filters = this.getDefaultFilters();
    }
    this.filterableHeaders = this.headers.filter((header) => header.filterType);
  },
};
</script>

<style>
.link-modal-button-container {
  position: relative;
  padding: 5px;
  height: 50px;
}

.link-filter-button {
  position: absolute;
  left: 10px;
  margin-bottom: 10px;
}
</style>
